import { makeStyles } from "@mui/styles";
import background from "../../assets/images/bg-sheeps-first.jpg";

const useAuthenticationStyles = makeStyles((theme) => ({
	root: {
		overflow: "hidden",
		width: "100vw",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundImage: `url(${background})`,
		backgroundPosition: "center",
		backgroundSize: "cover",
	},
	logo: {
		maxWidth: "500px",
		height: "100%",
		p: 0,
		my: 0,
	},
	subtitle: {
		color: theme.palette.secondary.main,
		letterSpacing: theme.spacing(0.1),
		maxWidth: "300px",
	},
}));

export default useAuthenticationStyles;
